<div class="FcAgEditor__MenuItem--IconContainer" [innerHTML]="html | sanitizeHtml" (mousedown)="toggle($event)"
     [title]="getTitle(name)">
</div>
